<template>
	<div class="control-icon" :class="`icon-${iconName}-${size}`" />
</template>

<script lang="ts" setup>
import type { IconTypes } from "@/types/ui";

interface Props {
	iconName: IconTypes;
	size?: number;
}

const { iconName, size = 56 } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.control-icon {
	&__wrapper {
		transition: all 0.2s ease-in-out;
		cursor: pointer;
		&--active {
			transform: scale(1.2);
		}
	}
}
</style>
